import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RequireAuth({ children }) {
  const { token, authLoading } = useAuth();
  const loc = useLocation();
  if (authLoading) return null;
  if (!token) return <Navigate to="/login" replace state={{ from: loc }} />;
  return children;
}
